import AddToCart from './AddToCart.vue'

export default AddToCart
